import { Chip } from '@mui/material'
import { FC } from 'react'

/** Marks today's court dates; `onFilled` is the white version for the filled calendar cards. */
export const CourtDateTodayChip: FC<{ onFilled?: boolean }> = ({ onFilled }) => (
  <Chip
    label="Today"
    size="small"
    variant="outlined"
    sx={{
      height: '14px',
      flexShrink: 0,
      fontSize: '9px',
      fontWeight: 600,
      borderColor: onFilled ? 'white' : 'primary.main',
      color: onFilled ? 'white' : 'primary.main',
      '& .MuiChip-label': { px: '6px' }
    }}
  />
)
